import { instance } from './config';

export const getAllRoles = () => {
   return instance.get('/role');
};
